var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "div",
        { staticClass: "subTitle" },
        [
          _c(
            "el-link",
            {
              attrs: {
                icon: "el-icon-arrow-left",
                underline: false,
                href: "#/ourProducts"
              }
            },
            [_vm._v("Content Management - Our Products")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "h3",
        {
          staticClass: "title",
          attrs: { content: "edit", placement: "bottom" }
        },
        [_vm._v("Edit Project")]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "formProject",
              staticClass: "formProject",
              attrs: {
                "label-width": "220px",
                "label-position": "left",
                model: _vm.formProject,
                rules: _vm.formProjectRules
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "detailContent",
                  staticStyle: { "margin-bottom": "25px" }
                },
                [
                  _c("div", { staticClass: "requireRmarks" }, [
                    _vm._v("*Required Fields")
                  ]),
                  _vm._v(" "),
                  _c("el-row", [_c("h4", [_vm._v("Regions")])]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Sales office",
                                prop: "salesOffice"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    multiple: "",
                                    "popper-append-to-body": false
                                  },
                                  on: { change: _vm.changeSalesOffice },
                                  model: {
                                    value: _vm.formProject.salesOffice,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formProject,
                                        "salesOffice",
                                        $$v
                                      )
                                    },
                                    expression: "formProject.salesOffice"
                                  }
                                },
                                _vm._l(_vm.salesOfficeList, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Region", prop: "region" } },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.formProject.region,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formProject, "region", $$v)
                                    },
                                    expression: "formProject.region"
                                  }
                                },
                                _vm._l(_vm.regionList, function(item, index) {
                                  return _c(
                                    "el-checkbox",
                                    { key: index, attrs: { label: item.code } },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("el-row", [_c("h4", [_vm._v("Languages")])]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "text-align": "left" },
                              attrs: {
                                label: "Supported Languages",
                                prop: "language"
                              }
                            },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.formProject.language,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formProject, "language", $$v)
                                    },
                                    expression: "formProject.language"
                                  }
                                },
                                _vm._l(_vm.languageList, function(item, index) {
                                  return _c(
                                    "el-checkbox",
                                    { key: index, attrs: { label: item.code } },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "detailContent" },
                [
                  _c("el-row", [_c("h4", [_vm._v("Project Details")])]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project type",
                                prop: "projectType"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { "popper-append-to-body": false },
                                  on: {
                                    change: function($event) {
                                      return _vm.investmentInitialAmounts(
                                        _vm.formProject.projectType
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.formProject.projectType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formProject,
                                        "projectType",
                                        $$v
                                      )
                                    },
                                    expression: "formProject.projectType"
                                  }
                                },
                                _vm._l(_vm.projectTypeList, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project Code",
                                prop: "projectCode",
                                rules: {
                                  required: true,
                                  message: "Project Code cannot be empty"
                                }
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { "popper-append-to-body": false },
                                  model: {
                                    value: _vm.formProject.projectCode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formProject,
                                        "projectCode",
                                        $$v
                                      )
                                    },
                                    expression: "formProject.projectCode"
                                  }
                                },
                                _vm._l(_vm.formProject.ProductsList, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("el-row", [_c("h4", [_vm._v("Project Name")])]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project Name (EN)",
                                prop: "projectNameEn",
                                rules: {
                                  required:
                                    _vm.formProject.language.indexOf("EN") != -1
                                      ? true
                                      : false,
                                  message: "Project Name (EN) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Please enter",
                                  maxlength: "30"
                                },
                                model: {
                                  value: _vm.formProject.projectNameEn,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "projectNameEn",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.projectNameEn"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project Name (JP)",
                                prop: "projectNameJp",
                                rules: {
                                  required:
                                    _vm.formProject.language.indexOf("JA") != -1
                                      ? true
                                      : false,
                                  message: "Project Name (JP) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Please enter",
                                  maxlength: "30"
                                },
                                model: {
                                  value: _vm.formProject.projectNameJp,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "projectNameJp",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.projectNameJp"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project Name (TC)",
                                prop: "projectNameTc",
                                rules: {
                                  required:
                                    _vm.formProject.language.indexOf("ZH_HK") !=
                                    -1
                                      ? true
                                      : false,
                                  message: "Project Name (TC) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Please enter",
                                  maxlength: "30"
                                },
                                model: {
                                  value: _vm.formProject.projectNameTc,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "projectNameTc",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.projectNameTc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project Name (SC)",
                                prop: "projectNameSc",
                                rules: {
                                  required:
                                    _vm.formProject.language.indexOf("ZH_CN") !=
                                    -1
                                      ? true
                                      : false,
                                  message: "Project Name (SC) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Please enter",
                                  maxlength: "30"
                                },
                                model: {
                                  value: _vm.formProject.projectNameSc,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "projectNameSc",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.projectNameSc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("el-row", [_c("h4", [_vm._v("Project Address")])]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project Country",
                                prop: "projectLocation"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { "popper-append-to-body": false },
                                  model: {
                                    value: _vm.formProject.projectLocation,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formProject,
                                        "projectLocation",
                                        $$v
                                      )
                                    },
                                    expression: "formProject.projectLocation"
                                  }
                                },
                                _vm._l(_vm.projectLocationList, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project State",
                                prop: "project_Status"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Please enter",
                                  maxlength: "50"
                                },
                                model: {
                                  value: _vm.formProject.project_Status,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "project_Status",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.project_Status"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project Region",
                                prop: "projectRegion"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Please enter",
                                  maxlength: "50"
                                },
                                model: {
                                  value: _vm.formProject.projectRegion,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "projectRegion",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.projectRegion"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project Address (EN)",
                                prop: "projectAddressEn",
                                rules: {
                                  required:
                                    _vm.formProject.language.indexOf("EN") != -1
                                      ? true
                                      : false,
                                  message:
                                    "Project Address (EN) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "150"
                                },
                                model: {
                                  value: _vm.formProject.projectAddressEn,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "projectAddressEn",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.projectAddressEn"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project Address (JP)",
                                prop: "projectAddressJp",
                                rules: {
                                  required:
                                    _vm.formProject.language.indexOf("JA") != -1
                                      ? true
                                      : false,
                                  message:
                                    "Project Address (JP) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "150"
                                },
                                model: {
                                  value: _vm.formProject.projectAddressJp,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "projectAddressJp",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.projectAddressJp"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project Address (TC)",
                                prop: "projectAddressTc",
                                rules: {
                                  required:
                                    _vm.formProject.language.indexOf("ZH_HK") !=
                                    -1
                                      ? true
                                      : false,
                                  message:
                                    "Project Address (TC) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "150"
                                },
                                model: {
                                  value: _vm.formProject.projectAddressTc,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "projectAddressTc",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.projectAddressTc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project Address (SC)",
                                prop: "projectAddressSc",
                                rules: {
                                  required:
                                    _vm.formProject.language.indexOf("ZH_CN") !=
                                    -1
                                      ? true
                                      : false,
                                  message:
                                    "Project Address (SC) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "150"
                                },
                                model: {
                                  value: _vm.formProject.projectAddressSc,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "projectAddressSc",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.projectAddressSc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("el-row", [_c("h4", [_vm._v("Project Details")])]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Property size",
                                prop: "propertySize"
                              }
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder: "Please enter",
                                    maxlength: "15"
                                  },
                                  model: {
                                    value: _vm.formProject.propertySize,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formProject,
                                        "propertySize",
                                        $$v
                                      )
                                    },
                                    expression: "formProject.propertySize"
                                  }
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("acres")
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "text-align": "left" },
                              attrs: { "label-width": "0" }
                            },
                            [
                              _vm.formProject.sizeUnit.indexOf(
                                "METER_SQUARE"
                              ) != -1
                                ? _c(
                                    "span",
                                    { staticStyle: { "margin-right": "20px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formProject.propertySize
                                            ? (
                                                _vm.formProject.propertySize *
                                                1 *
                                                4046.85642
                                              ).toFixed(3)
                                            : "0"
                                        ) + "㎡"
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.formProject.sizeUnit.indexOf("PING") != -1
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formProject.propertySize
                                          ? (
                                              _vm.formProject.propertySize *
                                              1 *
                                              1224.036
                                            ).toFixed(3)
                                          : "0"
                                      ) + "坪"
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Other size unit",
                                prop: "sizeUnit"
                              }
                            },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.formProject.sizeUnit,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formProject, "sizeUnit", $$v)
                                    },
                                    expression: "formProject.sizeUnit"
                                  }
                                },
                                _vm._l(_vm.unitList, function(item, index) {
                                  return _c(
                                    "el-checkbox",
                                    { key: index, attrs: { label: item.code } },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Total syndication price",
                                prop: "syndicationPrice"
                              }
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder: "Please enter",
                                    maxlength: "15"
                                  },
                                  model: {
                                    value: _vm.formProject.syndicationPrice,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formProject,
                                        "syndicationPrice",
                                        $$v
                                      )
                                    },
                                    expression: "formProject.syndicationPrice"
                                  }
                                },
                                [
                                  _c("template", { slot: "prepend" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formProject.projectLocation == "US"
                                          ? "USD"
                                          : "CAD"
                                      )
                                    )
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.formProject.salesOffice.indexOf("SG") != -1
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Minimal Investment Amount",
                                    prop: "amounts"
                                  }
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      attrs: {
                                        placeholder: "Please enter",
                                        maxlength: "15"
                                      },
                                      model: {
                                        value: _vm.formProject.amounts,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formProject,
                                            "amounts",
                                            $$v
                                          )
                                        },
                                        expression: "formProject.amounts"
                                      }
                                    },
                                    [
                                      _c("template", { slot: "prepend" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formProject.projectLocation ==
                                              "US"
                                              ? "USD"
                                              : "CAD"
                                          )
                                        )
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("el-row", [_c("h4", [_vm._v("Project Description")])]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project description (EN)",
                                prop: "descriptionEn",
                                rules: {
                                  required:
                                    _vm.formProject.language.indexOf("EN") != -1
                                      ? true
                                      : false,
                                  message:
                                    "Project description (EN) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  autosize: { minRows: 6, maxRows: 6 },
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "5000"
                                },
                                model: {
                                  value: _vm.formProject.descriptionEn,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "descriptionEn",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.descriptionEn"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project description (JP)",
                                prop: "descriptionJp",
                                rules: {
                                  required:
                                    _vm.formProject.language.indexOf("JA") != -1
                                      ? true
                                      : false,
                                  message:
                                    "Project description (JP) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  autosize: { minRows: 6, maxRows: 6 },
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "5000"
                                },
                                model: {
                                  value: _vm.formProject.descriptionJp,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "descriptionJp",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.descriptionJp"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project description (TC)",
                                prop: "descriptionTc",
                                rules: {
                                  required:
                                    _vm.formProject.language.indexOf("ZH_HK") !=
                                    -1
                                      ? true
                                      : false,
                                  message:
                                    "Project description (TC) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  autosize: { minRows: 6, maxRows: 6 },
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "5000"
                                },
                                model: {
                                  value: _vm.formProject.descriptionTc,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "descriptionTc",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.descriptionTc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project description (SC)",
                                prop: "descriptionSc",
                                rules: {
                                  required:
                                    _vm.formProject.language.indexOf("ZH_CN") !=
                                    -1
                                      ? true
                                      : false,
                                  message:
                                    "Project description (SC) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  autosize: { minRows: 6, maxRows: 6 },
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "5000"
                                },
                                model: {
                                  value: _vm.formProject.descriptionSc,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "descriptionSc",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.descriptionSc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("el-row", [_c("h4", [_vm._v("Project Brief")])]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project brief (EN)",
                                prop: "briefEn",
                                rules: {
                                  required:
                                    _vm.formProject.language.indexOf("EN") != -1
                                      ? true
                                      : false,
                                  message: "Project brief (EN) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "400"
                                },
                                model: {
                                  value: _vm.formProject.briefEn,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formProject, "briefEn", $$v)
                                  },
                                  expression: "formProject.briefEn"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project brief (JP)",
                                prop: "briefJp",
                                rules: {
                                  required:
                                    _vm.formProject.language.indexOf("JA") != -1
                                      ? true
                                      : false,
                                  message: "Project brief (JP) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "400"
                                },
                                model: {
                                  value: _vm.formProject.briefJp,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formProject, "briefJp", $$v)
                                  },
                                  expression: "formProject.briefJp"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project brief (TC)",
                                prop: "briefTc",
                                rules: {
                                  required:
                                    _vm.formProject.language.indexOf("ZH_HK") !=
                                    -1
                                      ? true
                                      : false,
                                  message: "Project brief (TC) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "30"
                                },
                                model: {
                                  value: _vm.formProject.briefTc,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formProject, "briefTc", $$v)
                                  },
                                  expression: "formProject.briefTc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project brief (SC)",
                                prop: "briefSc",
                                rules: {
                                  required:
                                    _vm.formProject.language.indexOf("ZH_CN") !=
                                    -1
                                      ? true
                                      : false,
                                  message: "Project brief (SC) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "400"
                                },
                                model: {
                                  value: _vm.formProject.briefSc,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formProject, "briefSc", $$v)
                                  },
                                  expression: "formProject.briefSc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("el-row", [
                    _c("h4", [_vm._v("Land Use / Current Zoning")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Land Use / Current Zoning (EN)",
                                prop: "landUseEn"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "500"
                                },
                                model: {
                                  value: _vm.formProject.landUseEn,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formProject, "landUseEn", $$v)
                                  },
                                  expression: "formProject.landUseEn"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Land Use / Current Zoning (JP)",
                                prop: "landUseJp"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "500"
                                },
                                model: {
                                  value: _vm.formProject.landUseJp,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formProject, "landUseJp", $$v)
                                  },
                                  expression: "formProject.landUseJp"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Land Use / Current Zoning (TC)",
                                prop: "landUseTc"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "500"
                                },
                                model: {
                                  value: _vm.formProject.landUseTc,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formProject, "landUseTc", $$v)
                                  },
                                  expression: "formProject.landUseTc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Land Use / Current Zoning (SC)",
                                prop: "landUseSc"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "500"
                                },
                                model: {
                                  value: _vm.formProject.landUseSc,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formProject, "landUseSc", $$v)
                                  },
                                  expression: "formProject.landUseSc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("el-row", [_c("h4", [_vm._v("Project Disclaimer")])]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project disclaimer (EN)",
                                prop: "disclaimerEn"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "5000"
                                },
                                model: {
                                  value: _vm.formProject.disclaimerEn,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "disclaimerEn",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.disclaimerEn"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project disclaimer (JP)",
                                prop: "disclaimerJp"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "5000"
                                },
                                model: {
                                  value: _vm.formProject.disclaimerJp,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "disclaimerJp",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.disclaimerJp"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project disclaimer (TC)",
                                prop: "disclaimerTc"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "5000"
                                },
                                model: {
                                  value: _vm.formProject.disclaimerTc,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "disclaimerTc",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.disclaimerTc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project disclaimer (SC)",
                                prop: "disclaimerSc"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  resize: "none",
                                  placeholder: "Please enter",
                                  maxlength: "5000"
                                },
                                model: {
                                  value: _vm.formProject.disclaimerSc,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "disclaimerSc",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.disclaimerSc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("el-row", [_c("h4", [_vm._v("Images")])]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "images" } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { display: "inline-block" },
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "font-size": "16px",
                                        "line-height": "normal"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Images (max.5 images)\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "14px",
                                        color: "rgb(79, 122, 150)"
                                      }
                                    },
                                    [_vm._v("Images size:1125(W) x 705(H)")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("upload-image", {
                                ref: "UploadImage",
                                attrs: {
                                  fileParams: _vm.imagesFileParams,
                                  fileList: _vm.imagesFileList,
                                  limit: 5,
                                  accept: "image"
                                },
                                on: { getSuccessRes: _vm.getImgRes }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "thumbnail" } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { display: "inline-block" },
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "font-size": "16px",
                                        "line-height": "normal"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Thumbnail (max.1 images)\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "14px",
                                        color: "rgb(79, 122, 150)"
                                      }
                                    },
                                    [_vm._v("Images size:981(W) x 390(H)")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("upload-image", {
                                ref: "UploadThumbnail",
                                attrs: {
                                  fileParams: _vm.thumbnailFileParams,
                                  fileList: _vm.thumbnailFileList,
                                  limit: 1,
                                  accept: "image"
                                },
                                on: { getSuccessRes: _vm.getThumbnailRes }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("el-row", [_c("h4", [_vm._v("Property in map")])]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "kmzFile", label: "KMZ file" } },
                            [
                              _c("upload-image", {
                                ref: "UploadKMZ",
                                attrs: {
                                  fileParams: _vm.KMZFileParams,
                                  fileList: _vm.KMZFileList,
                                  accept: "kmz",
                                  limit: 1
                                },
                                on: { getSuccessRes: _vm.getKMZRes }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("el-row", [_c("h4", [_vm._v("Property Factsheet")])]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "facesheetEn",
                                label: "Property Factsheet (EN)"
                              }
                            },
                            [
                              _c("upload-image", {
                                ref: "UploadFacesheetEn",
                                attrs: {
                                  fileParams: _vm.facesheetEnFileParams,
                                  fileList: _vm.facesheetEnFileList,
                                  limit: 1,
                                  accept: "pdf"
                                },
                                on: { getSuccessRes: _vm.getFacesheetEnRes }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "facesheetJp",
                                label: "Property Factsheet (JP)"
                              }
                            },
                            [
                              _c("upload-image", {
                                ref: "UploadFacesheetJp",
                                attrs: {
                                  fileParams: _vm.facesheetJpFileParams,
                                  fileList: _vm.facesheetJpFileList,
                                  limit: 1,
                                  accept: "pdf"
                                },
                                on: { getSuccessRes: _vm.getFacesheetJplRes }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "facesheetTc",
                                label: "Property Factsheet (TC)"
                              }
                            },
                            [
                              _c("upload-image", {
                                ref: "UploadFacesheetTc",
                                attrs: {
                                  fileParams: _vm.facesheetTcFileParams,
                                  fileList: _vm.facesheetTcFileList,
                                  limit: 1,
                                  accept: "pdf"
                                },
                                on: { getSuccessRes: _vm.getFacesheetTcRes }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "facesheetSc",
                                label: "Property Factsheet (SC)"
                              }
                            },
                            [
                              _c("upload-image", {
                                ref: "UploadFacesheetSc",
                                attrs: {
                                  fileParams: _vm.facesheetScFileParams,
                                  fileList: _vm.facesheetScFileList,
                                  limit: 1,
                                  accept: "pdf"
                                },
                                on: { getSuccessRes: _vm.getFacesheetSclRes }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("el-row", [_c("h4", [_vm._v("Video")])]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Video (EN)", prop: "videoEn" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Please enter" },
                                model: {
                                  value: _vm.formProject.videoEn,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formProject, "videoEn", $$v)
                                  },
                                  expression: "formProject.videoEn"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Video (JP)", prop: "videoJp" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Please enter" },
                                model: {
                                  value: _vm.formProject.videoJp,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formProject, "videoJp", $$v)
                                  },
                                  expression: "formProject.videoJp"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Traditional Chinese / Cantonese",
                                prop: "videoTc_c"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Please enter" },
                                model: {
                                  value: _vm.formProject.videoTc_c,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formProject, "videoTc_c", $$v)
                                  },
                                  expression: "formProject.videoTc_c"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Traditional Chinese / Mandarin",
                                prop: "videoTc_m"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Please enter" },
                                model: {
                                  value: _vm.formProject.videoTc_m,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formProject, "videoTc_m", $$v)
                                  },
                                  expression: "formProject.videoTc_m"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Simplified Chinese",
                                prop: "videoSc"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Please enter" },
                                model: {
                                  value: _vm.formProject.videoSc,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formProject, "videoSc", $$v)
                                  },
                                  expression: "formProject.videoSc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Another Language",
                                prop: "hasAnotherLanguage"
                              }
                            },
                            [
                              _c("el-switch", {
                                on: { change: _vm.handleAnotherLanguageChange },
                                model: {
                                  value: _vm.formProject.hasAnotherLanguage,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "hasAnotherLanguage",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.hasAnotherLanguage"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Language Name" } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop: "labelNameEn",
                                        rules: {
                                          required: _vm.formProject
                                            .hasAnotherLanguage
                                            ? true
                                            : false,
                                          message:
                                            "Language Name (EN) can not be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "English",
                                          maxlength: "20"
                                        },
                                        model: {
                                          value: _vm.formProject.labelNameEn,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formProject,
                                              "labelNameEn",
                                              $$v
                                            )
                                          },
                                          expression: "formProject.labelNameEn"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop: "labelNameJp",
                                        rules: {
                                          required: _vm.formProject
                                            .hasAnotherLanguage
                                            ? true
                                            : false,
                                          message:
                                            "Language Name (JP) can not be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "Japanese",
                                          maxlength: "20"
                                        },
                                        model: {
                                          value: _vm.formProject.labelNameJp,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formProject,
                                              "labelNameJp",
                                              $$v
                                            )
                                          },
                                          expression: "formProject.labelNameJp"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop: "labelNameTc",
                                        rules: {
                                          required: _vm.formProject
                                            .hasAnotherLanguage
                                            ? true
                                            : false,
                                          message:
                                            "Language Name (TC) can not be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "Traditional Chinese",
                                          maxlength: "20"
                                        },
                                        model: {
                                          value: _vm.formProject.labelNameTc,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formProject,
                                              "labelNameTc",
                                              $$v
                                            )
                                          },
                                          expression: "formProject.labelNameTc"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop: "labelNameSc",
                                        rules: {
                                          required: _vm.formProject
                                            .hasAnotherLanguage
                                            ? true
                                            : false,
                                          message:
                                            "Language Name (SC) can not be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "Simplified Chinese"
                                        },
                                        model: {
                                          value: _vm.formProject.labelNameSc,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formProject,
                                              "labelNameSc",
                                              $$v
                                            )
                                          },
                                          expression: "formProject.labelNameSc"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Corresponding URL",
                                prop: "videoAnother",
                                rules: {
                                  required: _vm.formProject.hasAnotherLanguage
                                    ? true
                                    : false,
                                  message: "Corresponding URL can not be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.formProject.videoAnother,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formProject,
                                      "videoAnother",
                                      $$v
                                    )
                                  },
                                  expression: "formProject.videoAnother"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("el-row", [_c("h4", [_vm._v("Project Status")])]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Project status",
                                prop: "projectStatus"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { "popper-append-to-body": false },
                                  model: {
                                    value: _vm.formProject.projectStatus,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formProject,
                                        "projectStatus",
                                        $$v
                                      )
                                    },
                                    expression: "formProject.projectStatus"
                                  }
                                },
                                _vm._l(_vm.projectStatusList, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "New project",
                                prop: "newProject"
                              }
                            },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-color": "#003448",
                                  "inactive-color": "#ccc"
                                },
                                model: {
                                  value: _vm.formProject.newProject,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formProject, "newProject", $$v)
                                  },
                                  expression: "formProject.newProject"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Post online",
                                prop: "postOnline"
                              }
                            },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-color": "#003448",
                                  "inactive-color": "#ccc"
                                },
                                model: {
                                  value: _vm.formProject.postOnline,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formProject, "postOnline", $$v)
                                  },
                                  expression: "formProject.postOnline"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.formProject.postOnline
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 50 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Online timeframe (Start)",
                                    prop: "onlineTimeS"
                                  }
                                },
                                [
                                  _c(
                                    "el-row",
                                    {
                                      staticStyle: { "margin-bottom": "0" },
                                      attrs: {
                                        gutter: 10,
                                        justify: "space-between",
                                        type: "flex"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { prop: "onlineTimeSD" } },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  type: "date",
                                                  "range-separator": "-",
                                                  format: "yyyy-MM-dd",
                                                  "value-format": "yyyy-MM-dd",
                                                  placeholder: "Date"
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.handleOnlineDateTime(
                                                      "S"
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.formProject
                                                      .onlineTimeSD,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formProject,
                                                      "onlineTimeSD",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formProject.onlineTimeSD"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { prop: "onlineTimeST" } },
                                            [
                                              _c("el-time-select", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  "picker-options": {
                                                    start: "00:00",
                                                    step: "00:15",
                                                    end: "24:00"
                                                  },
                                                  placeholder: "Time"
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.handleOnlineDateTime(
                                                      "S"
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.formProject
                                                      .onlineTimeST,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formProject,
                                                      "onlineTimeST",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formProject.onlineTimeST"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Online timeframe (End)",
                                    prop: "onlineTimeE"
                                  }
                                },
                                [
                                  _c(
                                    "el-row",
                                    {
                                      staticStyle: { "margin-bottom": "0" },
                                      attrs: {
                                        gutter: 10,
                                        justify: "space-between",
                                        type: "flex"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { prop: "onlineTimeED" } },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  type: "date",
                                                  "range-separator": "-",
                                                  format: "yyyy-MM-dd",
                                                  "value-format": "yyyy-MM-dd",
                                                  placeholder: "Date"
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.handleOnlineDateTime(
                                                      "E"
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.formProject
                                                      .onlineTimeED,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formProject,
                                                      "onlineTimeED",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formProject.onlineTimeED"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { prop: "onlineTimeET" } },
                                            [
                                              _c("el-time-select", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  "picker-options": {
                                                    start: "00:00",
                                                    step: "00:15",
                                                    end: "24:00"
                                                  },
                                                  placeholder: "Time"
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.handleOnlineDateTime(
                                                      "E"
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.formProject
                                                      .onlineTimeET,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formProject,
                                                      "onlineTimeET",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formProject.onlineTimeET"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: { padding: "25px 0" },
          attrs: { type: "flex", justify: "end", gutter: 20 }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _vm.showSave
                ? _c(
                    "el-button",
                    {
                      staticClass: "reset",
                      staticStyle: { width: "100%" },
                      on: { click: _vm.handleCancel }
                    },
                    [_vm._v("Cancel")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _vm.showSave
                ? _c(
                    "el-button",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSave }
                    },
                    [_vm._v("Create")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0915c8f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0915c8f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/product/editProjectClone.vue
// module id = null
// module chunks = 